export default "__VITE_ASSET__CZ8eWuNv__"